export default "__VITE_ASSET__CvE4QxZj__"